// Array
// last
// makeArr: 2 generics, return, overwrite inference, default value
// addFull Name : Extends
// interfaces
// props
// useState
// jsx generic

export const last = <T>(arr: Array<T>): T | undefined => {
	return arr[arr.length - 1];
};

// -----

const makeArr = <T, Y>(x: T, y: Y): [T, Y] => {
	return [x, y];
};
const val = makeArr(2, 'ok');
const val2 = makeArr<string | null, number>(null, 1);

// -----

export const makeFullName = <T extends { firstName: string; lastName: string }>(
	obj: T,
) => {
	return {
		...obj,
		fullName: obj.firstName + ' ' + obj.lastName,
	};
};

// -----

interface Tab<T> {
	id: string;
	position: number;
	data: T;
}

type NumberTab = Tab<Number>;
type StringTab = Tab<string>;
